export default "__VITE_ASSET__C5P8$$uW__"